"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function TypeUsesForm(_ref) {
  var data = _ref.data,
    onChanged = _ref.onChanged;
  var availableUses = (0, _react.useMemo)(function () {
    switch (data.type) {
      case 'P':
        return ['CP01'];
      case 'N':
        return ['CN01'];
      default:
        return ['G01', 'G02', 'G03', 'I01', 'I02', 'I03', 'I04', 'I05', 'I06', 'I07', 'I08', 'D01', 'D02', 'D03', 'D04', 'D05', 'D06', 'D07', 'D08', 'D09', 'D10', 'S01'];
    }
  }, [data]);
  return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12,
    sx: {
      mt: 2
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Card, {
    variant: "outlined"
  }, /*#__PURE__*/_react["default"].createElement(_commons.DataGrid, {
    items: availableUses,
    getId: function getId(item) {
      return item;
    },
    loading: false,
    hoverable: false,
    noBorderLastRow: true,
    selectable: {
      selected: data.uses,
      onChange: function onChange(ids, items) {
        onChanged(ids);
      }
    },
    columns: [{
      title: (0, _core.translate)('cfdi.uses.key'),
      converter: function converter(item) {
        return item;
      },
      id: 'id',
      xs: 2
    }, {
      title: (0, _core.translate)('cfdi.uses.title'),
      converter: function converter(item) {
        return (0, _core.translate)("cfdi.uses.".concat(item));
      },
      id: 'use',
      xs: true
    }]
  }))));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(TypeUsesForm);